import Glide from '@glidejs/glide';

document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.scroll-carousel');

  carousels.forEach((item) => {
    const glide = new Glide(item, {
      type: 'carousel',
      perView: 8,
      gap: 60,
      autoplay: 1,
      animationDuration: 3000,
      animationTimingFunc: 'linear',
      breakpoints: {
        1550: {
          perView: 7,
        },
        1350: {
          perView: 6,
        },
        1150: {
          perView: 5,
        },
        950: {
          perView: 4,
        },
      },
    });
    glide.mount();
  });
});
